export default "__VITE_ASSET__1a87df82__"